// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiSort from "lumi-sort/lib/es6/src/LumiSort.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as Spinner$Web from "lumi-web/lib/es6/src/Spinner.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Route$Dashboard from "./Route.res.js";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.res.js";
import * as NavBar$Dashboard from "./NavBar.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as PrintView$Dashboard from "./PrintView.res.js";
import * as RescriptReactRouter from "@rescript/react/lib/es6/src/RescriptReactRouter.res.js";
import * as Statistics$Dashboard from "./Statistics.res.js";
import * as Translation$Dashboard from "./Translation.res.js";
import * as Stallingsnet$LumiCentral from "lumi-central/lib/es6/src/Stallingsnet.res.js";
import * as Barrier$LumiAuthentication from "lumi-authentication/lib/es6/src/Barrier.res.js";
import * as AbandonedVehicles$Dashboard from "./AbandonedVehicles.res.js";
import * as CurrentOccupation$Dashboard from "./CurrentOccupation.res.js";
import * as ChangePassword$LumiAuthentication from "lumi-authentication/lib/es6/src/ChangePassword.res.js";

function Application(props) {
  let accountDoc = Barrier$LumiAuthentication.Account.useContext();
  let toAuth = Barrier$LumiAuthentication.Dispatch.useContext();
  let match = Route$Dashboard.useRoute();
  let routeUrl = match[1];
  let route = match[0];
  let match$1 = LumiReactReducer.useReducer(() => {
    let url = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined);
    let urlSearchParams = new URLSearchParams(url.search);
    return {
      TAG: "InitWithEffect",
      _0: {
        kiosk: Stdlib_Option.isSome(Primitive_option.fromNullable(urlSearchParams.get("kiosk"))),
        changePassword: false,
        facilityInfos: undefined,
        print: undefined
      },
      _1: param => {
        let dispatch = param.dispatch;
        return LumiRequest.resultFutureEffect(Stallingsnet$LumiCentral.getFacilities(), facilities => dispatch({
          TAG: "FacilityInfosReceived",
          _0: facilities
        }), err => {
          console.error("getFacilities failed", err);
          Barrier$LumiAuthentication.checkServerError(err, toAuth);
        });
      }
    };
  }, undefined, (state, action) => {
    if (typeof action !== "object") {
      return {
        TAG: "Update",
        _0: {
          kiosk: state.kiosk,
          changePassword: state.changePassword,
          facilityInfos: state.facilityInfos,
          print: undefined
        }
      };
    }
    switch (action.TAG) {
      case "FacilityInfosReceived" :
        return {
          TAG: "Update",
          _0: {
            kiosk: state.kiosk,
            changePassword: state.changePassword,
            facilityInfos: LumiSort.stableSortOn(action._0, param => Document$LumiStore.contents(param.facility).name),
            print: state.print
          }
        };
      case "ChangePassword" :
        return {
          TAG: "Update",
          _0: {
            kiosk: state.kiosk,
            changePassword: action._0,
            facilityInfos: state.facilityInfos,
            print: state.print
          }
        };
      case "Print" :
        return {
          TAG: "Update",
          _0: {
            kiosk: state.kiosk,
            changePassword: state.changePassword,
            facilityInfos: state.facilityInfos,
            print: action._0
          }
        };
    }
  });
  let dispatch = match$1[1];
  let state = match$1[0];
  let print = state.print;
  let kiosk = state.kiosk;
  let isPrinting = Stdlib_Option.isSome(print);
  let match$2 = state.facilityInfos;
  let tmp;
  if (match$2 !== undefined) {
    if (match$2.length !== 0) {
      if (typeof route !== "object") {
        tmp = JsxRuntime.jsx(Statistics$Dashboard.make, {
          facilityInfos: state.facilityInfos,
          kiosk: kiosk
        });
      } else {
        let match$3 = route._0;
        let map = match$3.map;
        tmp = match$3.tab === "CurrentOccupation" ? JsxRuntime.jsx(CurrentOccupation$Dashboard.make, {
            map: map,
            mapUrl: newMap => routeUrl({
              TAG: "Map",
              _0: {
                map: newMap,
                tab: "CurrentOccupation"
              }
            }),
            facilityInfos: state.facilityInfos,
            toApplication: dispatch
          }) : JsxRuntime.jsx(AbandonedVehicles$Dashboard.make, {
            map: map,
            mapUrl: newMap => routeUrl({
              TAG: "Map",
              _0: {
                map: newMap,
                tab: "AbandonedVehicles"
              }
            }),
            facilityInfos: state.facilityInfos,
            toApplication: dispatch
          });
      }
    } else {
      tmp = JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
          entry: {
            TAG: "NoAvailableFacilitiesForAccount",
            _0: Document$LumiStore.contents(accountDoc).name
          }
        }),
        className: "notification is-danger"
      });
    }
  } else {
    tmp = JsxRuntime.jsx(Spinner$Web.make, {});
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      print !== undefined ? JsxRuntime.jsx(PrintView$Dashboard.make, {
          element: print,
          dispatch: dispatch
        }) : JsxRuntime.jsx(NavBar$Dashboard.make, {
          kiosk: kiosk,
          route: route,
          routeUrl: routeUrl,
          dispatch: dispatch
        }),
      state.changePassword ? JsxRuntime.jsx(ChangePassword$LumiAuthentication.make, {
          onClose: () => dispatch({
            TAG: "ChangePassword",
            _0: false
          })
        }) : null,
      JsxRuntime.jsx("div", {
        children: tmp,
        className: LumiReact.classList([
          [
            "columns",
            true
          ],
          [
            "fill-available",
            true
          ],
          [
            "is-hidden",
            isPrinting
          ]
        ])
      })
    ]
  });
}

let T;

let make = Application;

export {
  T,
  make,
}
/* LumiReact Not a pure module */
